export const formSectionsTranslations = {
    BUSINESS_INFO: 'Business Info',
    BUSINESS_FINANCE: 'Business Finance',
    EMPLOYEES_AND_CONTRACTORS: 'Employees & Contractors',
    EXPERIENCE_APPLYING: 'Experience Applying for Loan / Credit',
    FINANCIAL_INFO_PRIMARY_CONTACT: 'Financial Info - Primary Contact',
    HOUSEHOLD_INFO_PRIMARY_CONTACT: 'Household Information - Primary Contact',
    OWNER_INFO: 'Owner/Operator Information',
    CONTACT: 'Contact',
    CONTACTS: 'Contacts',
    FINANCING: 'Financing',
    EMPLOYEES: 'Employees',
    PERSONAL: 'Personal',
    CHALLENGES: 'Challenges',
    'Business Info': 'Business Info',
    'Business Finance': 'Business Finance',
    'Employees & Contractors': 'Employees & Contractors',
    'Experience Applying for Loan / Credit': 'Experience Applying for Loan / Credit',
    'Financial Info - Primary Contact': 'Financial Info - Primary Contact',
    'Household Information - Primary Contact': 'Household Information - Primary Contact',
    'Owner/Operator Information': 'Owner/Operator Information',
    Contact: 'Contact',
    Contacts: 'Contacts',
    Finance: 'Financing',
    Employees: 'Employees',
    Personal: 'Personal',
    Challenges: 'Challenges',
    'Primary Contact': 'Primary Contact',
    PROFIT_LOSS: 'Profit & Loss',
    BALANCE_SHEET: 'Balance Sheet',
    JOBS: 'Jobs'
};
